import {Request} from "../../request.abstract";
import {Observable} from "rxjs/Observable";
import {PokeGroup} from "./api.models";
import {Http} from "@angular/http";
import {Settings} from "../../settings.model";

export class ImportsEndpoint extends Request {
    protected messagecentralId: number;

    constructor(http: Http, settings: Settings, id: number) {
        super(http, settings);

        this.messagecentralId = id;
    }

    group(from: string, to: string, amount: number): Observable<PokeGroup> {
        return this.post(
            '/v1/messagecentrals/' + this.messagecentralId + '/imports',
            {
                from: from,
                to: to,
                amountRequested: amount
            }
        );
    }

    collection(page: number, perPage: number): Observable<any> {
        return this.get(
            '/v1/messagecentrals/' + this.messagecentralId + '/imports',
            this.createSearch({
                page    : page,
                perPage : perPage
            })
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messagecentrals/imports/api.service.ts